import { useAuth0 } from "src/hooks/useAuth";
import React, { PropsWithChildren } from "react";
import { IRoute } from "src/Routes/RouteConfig";
import { check, getRoutePermission } from "src/Routes/RouteHelpers";
import envConfig from "../../../envConfig/envHelper";

interface IProps {
  route: IRoute;
}

export const Allowed = (props: PropsWithChildren<IProps>) => {
  const { user } = useAuth0();
  const { children, route } = props;

  const permissions = user ? Object.values(envConfig.auth.permissions) : [];
  const required = getRoutePermission(route.path);

  return check(permissions, required) ? <>{children}</> : null;
};
